<script>

import apiService from 'src/services/ApiService';
import sgsUtils from './SgsUtils';

export default {
  props: [
    "payload",
    "callback"
  ],
  components: {
  },
  data () {
    return {
      showDialog: true,

      gridData: [],
      filter: '',
      uriFilter: {
        itemsPerPage: 100,
        currentPage: 1
      },
      localObject: {}
    }
  },
  watch: {
    filter (val) {
      if (val.length > 2 || val == "") {
        this.load();
      }
    },
    showModal (val) {
      if (val) {
        this.filter = '';
        this.load();
      }
    }
  },
  methods: {
    closeModal: function() {
      this.showModal = false;
      this.$emit('autoCompleteClose');
    },
    selectRow: function (row) {
      this.callback(row);
      this.closeModal();
    },
    load: function() {

      let data = this._uriFilterList;

      data._ = {
        formId: this.formIdentifier.formId,
        fieldId: this.attr.id
      };

      let instanceConfig = (this.instance && this.instance._config) ? this.instance._config[this.attr.columnName] : null;

      if (instanceConfig != undefined) {
        if (instanceConfig.dependsOfSource != undefined) {
          this.attr.dependsOfSource = instanceConfig.dependsOfSource
        }
        if (instanceConfig.dependsOfTarget != undefined) {
          this.attr.dependsOfTarget = instanceConfig.dependsOfTarget
        }
      }

      if (this.instance && this.attr &&
        this.attr.dependsOfSource && this.attr.dependsOfTarget &&
        this.instance[this.attr.dependsOfSource]) {

        data._.dependsOfTarget = this.attr.dependsOfTarget;
        data._.dependsOfQuery = this.instance[this.attr.dependsOfSource];
      }

      return apiService.post({
        uri: this.attr.uri,
        data: data,
        excludeApi: true
      }).then(response => {
        this.gridData = response.data;
      });
    }
  },
  computed: {
    attr: function() {
      if (this.payload) {
        return this.payload.attr;
      }
      return [];
    },
    formIdentifier: function() {
      if (this.payload) {
        return this.payload.formIdentifier;
      }
    },
    instance: function() {
      if (this.payload) {
        return this.payload.instance;
      } else {
        return _config = {}
      }
    },
    getTitle: function () {
      return sgsUtils.getLabel({
        attr: this.attr,
        locale: this.$i18n.locale,
        label: ""
      });
    },
    _uriFilterList: function () {
      let newObj = Object.assign({}, this.uriFilter);

      if (this.attr) {

        let uriFilterList = this.attr.uriFilterList;
        let uriFilterListEs = this.attr.uriFilterListEs;
        let uriFilterListEn = this.attr.uriFilterListEn;

        if (this.$i18n.locale == 'es' && uriFilterListEs.length > 0) {
          uriFilterList = uriFilterListEs;
        } else if (this.$i18n.locale == 'en' && uriFilterListEn.length > 0) {
          uriFilterList = uriFilterListEn;
        }

        if (uriFilterList) {
          uriFilterList.map(item => {
            newObj[item] = this.filter;
          });
        }
      }

      return newObj;
    },
    _columnsToShow: function() {

      let list = [];

      let columnsToShow = this.attr.columnsToShow;
      let columnsToShowAttr = this.attr.columnsToShowAttr;

      if (this.$i18n.locale == 'es' && this.attr.columnLabelEs) {
        columnsToShow = this.attr.columnsToShowEs;
        columnsToShowAttr = this.attr.columnsToShowEsAttr;
      } else if (this.$i18n.locale == 'en' && this.attr.columnLabelEn) {
        columnsToShow = this.attr.columnsToShowEn;
        columnsToShowAttr = this.attr.columnsToShowEnAttr;
      }

      _.forOwn(columnsToShow, (value, key) => {

        let label = key;

        let itemToAdd = {
          label: value,
          value: key,
          attr: columnsToShowAttr[key]
        };

        list.push(itemToAdd);
      })
      return list
    }
  },
  mounted: function() {
    this.load();
  },
  created() {
  }
}
</script>

<template>
  <div>

    <el-dialog :title="getTitle" :visible.sync="showDialog" @close="closeModal">

      <el-row class="margin-bottom-30">
        <el-col :span="24">
          <el-input v-model="filter"/>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">

          <el-table :data="gridData" height="300" stripe>

            <el-table-column
              v-for="item in _columnsToShow"
              :label="item.label"
              inline-template>
              <SgsRender
                :type="item.attr.type"
                moduleType="list"
                :attr="item.attr"
                :fieldValue="row[item.value]"
                :formIdentifier="formIdentifier"
              />
            </el-table-column>

            <el-table-column
              inline-template>
              <el-button
                size="mini"
                type="primary"
                @click.prevent="selectRow(row)">
                Selecione
              </el-button>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

    </el-dialog>
  </div>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// AutoComplete.vue?69b906c9